/**
 * Creates a smooth fade-out overlay before logout redirect.
 * This prevents the visual "flicker" between React app and native loader.
 */
export function showLogoutTransition(): Promise<void> {
  return new Promise((resolve) => {
    // Create overlay element
    const overlay = document.createElement("div");
    overlay.id = "logout-transition-overlay";
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      z-index: 99999;
      background-color: #0b1f33;
      opacity: 0;
      transition: opacity 300ms ease-out;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: all;
    `;

    // Add animated CheckMaty logo (matches index.html native loader)
    overlay.innerHTML = `
      <div style="text-align:center;">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" style="margin:0 auto 16px;" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="#fed400" stroke-width="2" opacity="0.3"/>
          <circle cx="12" cy="12" r="10" stroke="#fed400" stroke-width="2" stroke-dasharray="63" stroke-dashoffset="63" style="animation:circle-fill 1.5s ease-out forwards"/>
          <path d="M8 12l3 3 5-5" stroke="#fed400" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="15" stroke-dashoffset="15" style="animation:check-draw 0.5s ease-out 0.5s forwards"/>
        </svg>
        <div style="font-size:15px;font-weight:500;color:#fed400;">CheckMaty</div>
      </div>
      <style>
        @keyframes circle-fill{to{stroke-dashoffset:0}}
        @keyframes check-draw{to{stroke-dashoffset:0}}
      </style>
    `;

    document.body.appendChild(overlay);

    // Trigger fade-in animation
    requestAnimationFrame(() => {
      overlay.style.opacity = "1";
    });

    // Wait for animation to complete before resolving
    setTimeout(resolve, 350);
  });
}
